module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[117]360.6cfa858.woff2";